import 'jquery-ui';
import Swiper from 'swiper/js/swiper';
import './goToPage';
import './blogFilters';
import './magnific-popup.min';

// Object-fit fallback
const userAgent = window.navigator.userAgent;

/**
 * Check whether the browser is Internet Explorer.
 *
 * @return {boolean}
 */
const isIe = () => {
    return userAgent.indexOf('Trident/') > 0;
};

/**
 * Check whether the browser is Edge.
 *
 * @return {boolean}
 */
const isEdge = () => {
    return userAgent.indexOf('Edge/') > 0;
};


if (isIe()) {
    $('.js-image-fit').each((i, container) => {
        const $container = $(container);
        const $image = $container.find('img');
        const imageSource = $image.attr('src') || $image.data('src');

        $container.css('background-image', `url(${imageSource})`);
        $image.addClass('sr-only');
    });
}

const $win = $(window);
const $doc = $(document);
const $body = $('body');
const isTablet = 1023;

function convertUKDateStringToUSDateString(date){
    var dateParts = date.split("/");
    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject.toString();
}

function scrollNext(el, _parent_class){
    var _top_offset = 140;
    if($(el).hasClass('two-column') || $(el).hasClass('float-right') && $('body').width() <= 766){
        _top_offset += 530;
    }

    let curRef = $(el).data('ref');
    if(typeof curRef === 'undefined'){
        let dest = $(el).closest(_parent_class).next();
        let curID = $(dest).attr('id');
        if(typeof curID === 'undefined'){
            dest = $(el).next(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            dest = $(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            let newId = "id-"+Math.floor(Math.random() * 999);
            $(dest).attr('id', newId);
            curRef = '#'+newId;
            $(el).data('ref', curRef);
        }
        else{
            curRef = '#'+curID;
            $(el).data('ref', curRef);
        }
    }

    $('html, body').animate({
        scrollTop: (parseInt($(curRef).offset().top) - _top_offset)
    }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        //window.location.hash = curRef;
    });
}

(function(window, document, $) {
    // Tabs
    const initTabs = () => {
    const activeTabClass = 'is-current';

        $('.tabs__nav a').on('click', function(event) {
            event.preventDefault();

            const $tabLink = $(this);
            const $targetTab = $($tabLink.attr('href'));

            $tabLink
                .parent()
                .add($targetTab)
                .addClass(activeTabClass)
                    .siblings()
                    .removeClass(activeTabClass);
        });
    }

    initTabs();

    // Datepicker
    $(function() {
        $(".datepicker-book").datepicker({ dateFormat: 'dd/mm/yy' });
        $('.home .section-amenities').each(function(k,v){
            $(v).find('li').first().addClass("active");
        });

        $('.home .section-amenities .slider_button').on('click', function(){
            if($(this).hasClass('prev')){
                var act = $(this).next().find('.active');
                if($(act).prev().length){
                    $(act).prev().addClass('active');
                }else{
                    $('.home .section-amenities').find('li').last().addClass("active");
                }
                $(act).removeClass('active');
            }else{
                var act = $(this).prev().find('.active');
                if($(act).next().length){
                    $(act).next().addClass('active');
                }else{
                    $('.home .section-amenities').find('li').first().addClass("active");
                }
                $(act).removeClass('active');
            }
        });

        setInterval(function(){
            $('.home .section-amenities .slider_button.next').trigger("click");
        },5000);
    });

    if($('#arrival').length && $('#departure').length && $('#numNights').length){

        $('#booking-form').submit(function(e){

            $('#booking-form .alert').remove();

            if($('#arrival').val() && $('#departure').val()){

                var arrival = convertUKDateStringToUSDateString($('#arrival').val())
                var departure = convertUKDateStringToUSDateString($('#departure').val())
                var date1 = new Date(arrival);
                var date2 = new Date(departure);

                // To calculate the time difference of two dates
                var Difference_In_Time = date2.getTime() - date1.getTime();

                // To calculate the no. of days between two dates
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                $('#numNights').val(Difference_In_Days);

            } else {
                $('#booking-form .form__inner .form__body').append('<div class="alert alert-danger">Please enter a date in the format dd/mm/yyyy</div>');
                e.preventDefault();
            }
        });
    }

    // Burger-menu
    $('.js-burger').on('click', function (ev) {
        ev.preventDefault();
        $(this).toggleClass('active');
        $('.js-burger-menu').toggleClass('active');
        $body.toggleClass('mobile-active');
    });

     //Mobile Dropdown
     $('.sub-menu').siblings('a').on('click', function(ev) {
        if ($(window).width() < isTablet) {
            if(!$(this).closest('a').hasClass('menu-item-active')) {
                ev.preventDefault();
            }

            $(this).siblings('.sub-menu').slideDown();
            $(this).closest('a').toggleClass('menu-item-active');
        };
    });

    // Sliders
    const $roomsSliderContainer = $('.js-slider-rooms')
    const roomsSlider = new Swiper ($roomsSliderContainer, {
        navigation: {
            nextEl: '.slider__button-next',
            prevEl: '.slider__button-prev',
        },
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,
        spaceBetween: 0,
        watchOverflow: true,
    });

    const $weddingGallerySliderContainer = $('.js-slider-wedding-gallery')
    const weddingGallerySlider = new Swiper ($weddingGallerySliderContainer, {
        navigation: {
            nextEl: '.slider__button-wedding-next',
            prevEl: '.slider__button-wedding-prev',
        },
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetweenSlides: 10,
            },
        },
        watchOverflow: true,
    });

    $(".js-slider-room-individual").each(function(index, element){
        let $this = $(this);
        $this.addClass("sri-instance-" + index);
        $this.parent().find(".slider__button-individual-prev").addClass("btn-prev-" + index);
        $this.parent().find(".slider__button-individual-next").addClass("btn-next-" + index);

        let swiper = new Swiper(".sri-instance-" + index, {
            navigation: {
                nextEl: ".btn-next-" + index,
                prevEl: ".btn-prev-" + index,
            },
              slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },

            centeredSlides: true,
            spaceBetween: 0,
            watchOverflow: true,
        });
    });

    $(".js-slider-arboretum-gallery").each(function(index, element){
        let $this = $(this);
        $this.addClass("sag-instance-" + index);
        $this.parent().find(".slider__button-arboretum-prev").addClass("btn-prev-" + index);
        $this.parent().find(".slider__button-arboretum-next").addClass("btn-next-" + index);

        let swiper = new Swiper(".sag-instance-" + index, {
            navigation: {
                nextEl: ".btn-next-" + index,
                prevEl: ".btn-prev-" + index,
            },
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },

            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 10
                },
            },
            observer: true,
            observeParents: true,
            watchOverflow: true,
        });
    });

    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });

    let scrollTop = 0;
    $(window).scroll(function ()
    {
        scrollTop = $(window).scrollTop();

        let SCROLL_THRESHOLD = 30;
        if(SCROLL_THRESHOLD > scrollTop){
            $('.header_home_anchor').addClass('header_home');
        }
        else{
            $('.header_home_anchor').removeClass('header_home');
        }
    });

    if($('.hero-image-slider').length > 0){
        // Hero Image Sliders
        const $heroSliderContainer = $('.hero-image-slider');
        const heroSlider = new Swiper ($heroSliderContainer, {
            slidesPerView: 1,
            effect: 'fade',
            crossFade: true,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            centeredSlides: true,
            spaceBetween: 0,
            watchOverflow: true,
        });
    }

    $('.scroll_next').on('click', function (ev) {
        var _container = $(this).data('container');
        scrollNext(this, _container);
    });

    //-- manual same height function
    let _block_names = [];
    _block_names.push('leighpark-text-image');

    $.each(_block_names, function( index, value ) {
        $('.' + value).each(function(){
            let _this = this;
            let cardwrapper = $(_this).find('.section__content');
            let cardwrapper_height = cardwrapper.outerHeight();
            $(_this).find('.section__aside').height(cardwrapper_height);
        });
    });

})(window, document, window.jQuery);
